export default __webpack_public_path__ + "static/media/front.6aa4da46.png";